import apiClient from "./axios"

export const getYears = async (params = {}) => {
  const { data } = await apiClient.get("/years", { params })
  return data
}

export const getYear = async (id) => {
  const { data } = await apiClient.get(`/years/${id}`)
  return data
}

export const createYear = async (payload) => {
  const { data } = await apiClient.post("/years", payload)
  return data
}

export const editYear = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/years/${id}`, payload)
  return data
}

export const deleteYear = async (id) => {
  const { data } = await apiClient.delete(`/years/${id}`)
  return data
}
